import {Button, Confirm, Header, Icon, Label} from "semantic-ui-react";
import React, {useEffect, useState} from "react";
import {PaymentDetails} from "./PaymentDetailsContainer";
import UseDifferentPaymentMethod from "./useDifferentPaymentMethod";
import StripePaymentError from "./stripePaymentError";
import PlaidMicroDeposits from "./plaidMicroDeposits";
import {CustomGrid, CustomModalHeader} from "../custom-common";

const MicroDepositsBankAccount = ({YourCost, removeBankAccount, strings, plaidEnviroment, setPlaidData}) => {

    const {
        microDepositsBankAccountPmData,
        verificationStatus,
        removePm,
    } = PaymentDetails.useContainer();

    const {plaidLinkToken, accountId} = microDepositsBankAccountPmData
    const [showConfimationModal, setShowConfirmationModal] = useState(false)
    const [verificationStatusLabelStyle, setVerificationStatusLabelStyle] = useState("")
    const [verificationStatusIconStyle, setVerificationIconStyle] = useState("")

    useEffect(()=>{
        switch (verificationStatus) {
            case "Unable to verify":
                setVerificationStatusLabelStyle("label-verificationStatus label-bkgWarning50")
                setVerificationIconStyle("icon-secondary-persimmon  icon-small icon-vertical-align")
                break
            case "Pending verification":
                setVerificationStatusLabelStyle("label-verificationStatus label-bkgSunshade50")
                setVerificationIconStyle("icon-primary-sunshade icon-small icon-vertical-align")
                break
            default:
                setVerificationStatusLabelStyle("label-verificationStatus label-bkgWarning50")
                setVerificationIconStyle("icon-primary-sunshade icon-small icon-vertical-align")
                break
        }
    },[verificationStatus])

    const handleUseDifferentPaymentMethod = () => {
        if (verificationStatus === "Pending verification") {
            setShowConfirmationModal(true)
        }
        if (verificationStatus === "Unable to verify") {
            removeBankAccount(accountId)
            removePm()
        }
    }

    return (
        <>
            <div>
                <StripePaymentError strings={strings} paymentMethod={strings.bankAccount}/>
                <Header className={'microDepositsBankAccountHeader'}>
                    <strong>{strings.bankAccount}</strong>
                </Header>
                <p className={'neutral700Text small'} style={{margin: '4px 0px 6px 1px'}}>{`${microDepositsBankAccountPmData.name}`}</p>
                <CustomGrid.Row >
                    <CustomGrid.Column>
                        <Label className={`${verificationStatusLabelStyle} normal`} compact size={"mini"}>
                            <p className={'blackColorText'} style={{ fontSize: '14px', fontWeight: '400'}} >
                                    <Icon className={verificationStatusIconStyle} name="circle" />
                                {verificationStatus}
                            </p>
                        </Label>
                        <PlaidMicroDeposits
                            plaidEnviroment={plaidEnviroment}
                            plaidLinkToken={plaidLinkToken}
                            setPlaidData={setPlaidData}
                            loading={false}
                            removePm={removePm}
                            verificationStatus={verificationStatus}
                        />
                    </CustomGrid.Column>
                </CustomGrid.Row>
                {YourCost}
                <UseDifferentPaymentMethod
                    strings={strings}
                    hideMethod={handleUseDifferentPaymentMethod}
                />
            </div>
            { verificationStatus === "Pending verification" &&
                <Confirm
                    open={showConfimationModal}
                    style={{maxWidth: '517.89'}}
                    size='tiny'
                    header={<CustomModalHeader title={strings.removePendingverificationModalHeader}
                                               onClose={() => {setShowConfirmationModal(false)}}/>}
                    content={strings.removePendingverificationModalContent}
                    cancelButton={<Button className={"emptyButton"} content={strings.cancel} onClick={() => {
                        setShowConfirmationModal(false);
                    }}/>}
                    confirmButton={<Button content={strings.removePendingverificationModalConfirm} onClick={() => {
                        removeBankAccount(accountId);
                        removePm();
                        setShowConfirmationModal(false);
                    }}/>}
                />
            }
        </>
    );
}

export default MicroDepositsBankAccount
